module.exports = __webpack_public_path__ + "static/media/4_of_spades.41079b8d.png";